import { Box, Heading } from "@chakra-ui/react"

import {
  selectDepositActionStatus,
  selectDepositActionType,
  useDappSelector,
} from "#/redux-state"
import ModalContainer from "#/shared/components/ModalContainer"
import { useBoostModal } from "#/shared/hooks"
import { MezoModalProps } from "#/shared/types"
import ModalLeave from "#/ui-old/Modal/ModalLeave"

import BoostModalBoostDuration from "./BoostModalBoostDuration"
import BoostModalButton from "./BoostModalButton"
import BoostModalCompleted from "./BoostModalCompleted"
import BoostModalHeader from "./BoostModalHeader"

export default function BoostModal({ isOpen, onClose }: MezoModalProps) {
  const lockStatus = useDappSelector(selectDepositActionStatus)
  const lockType = useDappSelector(selectDepositActionType)

  const {
    showLeaveModal,
    closeModal,
    leaveModal,
    closeCompletedModal,
    backToModal,
  } = useBoostModal(onClose)

  const modalContent =
    lockStatus === "completed" ? (
      <BoostModalCompleted onClose={closeCompletedModal} />
    ) : (
      <>
        <BoostModalHeader />
        <BoostModalBoostDuration />
        <BoostModalButton />
      </>
    )

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={closeModal}
      width="742px"
      isCentered={false}
      props={{ mt: "80px" }}
    >
      <Heading variant="h2" color="primary.white.100" mb="45px">
        {lockType === "extend"
          ? "Boost HODL score!"
          : "Resume HODL score boost"}
      </Heading>
      <Box w="720px" ml="11px" bg="primary.white.100" rounded="24px" p={10}>
        {showLeaveModal ? (
          <ModalLeave
            header="Leave boost?"
            stayText="Stay, I'm boosting"
            leaveModalText="Leave, not boosting"
            onClose={leaveModal}
            backToProcessTrigger={backToModal}
          />
        ) : (
          modalContent
        )}
      </Box>
    </ModalContainer>
  )
}
